/* eslint-disable max-len */
import { createElFromString } from './createElFromString';

const arrowSvg = `
    <svg width="34" height="60" viewBox="0 0 34 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g class="pixel-arrow__bg-main">
            <path d="M34.0415 26.3006H25.5415V17.8006H17.0315V9.29059H8.53149V0.790588H0.0314941V10.4906V17.8006V20.2006V22.0506V32.8106V34.8006V43.3106V51.8106V60.3106H8.56149V51.8106H17.0715V43.3106H25.5715L25.5515 34.8006H34.0415V26.3006Z" />
        </g>
        <g class="pixel-arrow__bg-top-shadow">
            <path d="M8.53149 9.29059H17.0315V18.7906H8.53149V9.29059Z" />
            <path d="M16.0415 17.8006H25.5415V26.3006H16.0415V17.8006Z" />
            <path d="M24.5415 26.3006H34.0415V34.8006H24.5415V26.3006Z" />
        </g>
        <g class="pixel-arrow__bg-bottom-shadow">
            <path d="M9.56149 41.3106V32.8106H0.0314941V60.3106H8.56149V51.8106H17.0715V41.3106H9.56149Z" />
        </g>
        <g class="pixel-arrow__bg-main">
            <path d="M25.5415 26.3006H17.0315V17.8006H8.53149V0.790588H0.0314941V34.8006H8.57149V43.3106H25.5715L25.5415 26.3006Z" />
        </g>
    </svg>
`;

export const createPixelArrowHtml = ({
    direction = 'right', classes = '', attributes = {}
}) => {
    const attributesString = Object.entries(attributes).reduce((accumulator, [key, value]) => `${accumulator} ${key}=${value}`, '');

    return `
        <button class="pixel-arrow pixel-arrow--${direction} ${classes}" ${attributesString}>
            <span class="pixel-arrow__inner pixel-arrow__inner--freezed">
                ${arrowSvg}
            </span>
            <span class="pixel-arrow__inner pixel-arrow__inner--active">
                ${arrowSvg}
            </span>
        </button>
    `;
};

export const createPixelArrowEl = (...args) => {
    const html = createPixelArrowHtml(...args);

    return createElFromString(html);
};
